// Calendar drag-to-create prefill logic (from /AvailabilityCalendar).
// Extracted from contract-create.ts to keep the page orchestrator thin.

interface CalendarPrefillConfig {
    prefillDiv: HTMLElement | null;
    prefillOfferId: number;
    prefillOfferUnitId: number;
    prefillCheckIn: string;
    prefillCheckOut: string;
    accommodationSelect: HTMLSelectElement;
    accommodationPricesContent: HTMLElement;
}

export interface CalendarPrefill {
    applyOffer(): void;
    applyDates(): void;
}

export function createCalendarPrefill(config: CalendarPrefillConfig): CalendarPrefill {
    const {
        prefillDiv, prefillOfferId, prefillOfferUnitId,
        prefillCheckIn, prefillCheckOut,
        accommodationSelect, accommodationPricesContent,
    } = config;

    let offerApplied = false;
    let datesApplied = false;

    function applyOffer(): void {
        if (offerApplied || !prefillDiv || isNaN(prefillOfferId)) return;
        offerApplied = true;

        const listboxItem = document.querySelector<HTMLElement>(
            `.cc-offer-listbox [data-value="${prefillOfferId}"]`
        );
        if (listboxItem) {
            listboxItem.click();
        } else {
            const opt = Array.from(accommodationSelect.options)
                .find(o => parseInt(o.value) === prefillOfferId);
            if (opt) {
                opt.selected = true;
                accommodationSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    function clamp(v: string, min: string, max: string): string {
        if (!v) return v;
        if (min && v < min) return min;
        if (max && v > max) return max;
        return v;
    }

    // Called on every price-change until the unit card appears (lazy retry pattern).
    function applyDates(): void {
        if (datesApplied || !prefillDiv || (!prefillCheckIn && !prefillCheckOut)) return;
        if (isNaN(prefillOfferUnitId)) return;

        const unitCard = accommodationPricesContent.querySelector<HTMLElement>(
            `.cc-unit-selection-card[data-unit-id="${prefillOfferUnitId}"]`
        );
        if (!unitCard) return;

        const fromPicker = unitCard.querySelector<HTMLInputElement>('.sub-range-from-picker');
        const toPicker   = unitCard.querySelector<HTMLInputElement>('.sub-range-to-picker');
        if (!fromPicker || !toPicker) return;

        datesApplied = true;

        if (prefillCheckIn) {
            fromPicker.value = clamp(prefillCheckIn, fromPicker.min, fromPicker.max);
            fromPicker.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (prefillCheckOut) {
            toPicker.value = clamp(prefillCheckOut, toPicker.min, toPicker.max);
            toPicker.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    return { applyOffer, applyDates };
}
